import { X, FileText, Loader, Check, AlertCircle } from "lucide-react";
import { useI18n } from "../i18n";

export type AttachmentStatus = "uploading" | "ready" | "error";

export interface PendingAttachment {
  id: string;               // local UUID for tracking
  file: File;
  status: AttachmentStatus;
  serverResponse?: {
    id: string;
    filename: string;
    media_type: string;
    size_bytes: number;
    url?: string;            // data URL for images
    extractedText?: string;  // extracted text for documents
  };
  previewUrl?: string;       // local blob URL for image preview
  error?: string;
}

interface AttachmentPreviewProps {
  attachments: PendingAttachment[];
  onRemove: (id: string) => void;
}

export function AttachmentPreview({ attachments, onRemove }: AttachmentPreviewProps) {
  const { t } = useI18n();
  if (attachments.length === 0) return null;

  return (
    <div className="attachment-preview">
      {attachments.map((att) => (
        <div key={att.id} className={`attachment-preview__item attachment-preview__item--${att.status}`}>
          {att.previewUrl ? (
            <img
              src={att.previewUrl}
              alt={att.file.name}
              className="attachment-preview__thumb"
            />
          ) : (
            <div className="attachment-preview__icon">
              <FileText size={20} />
            </div>
          )}
          <span className="attachment-preview__name" title={att.file.name}>
            {att.file.name}
          </span>
          <div className="attachment-preview__status">
            {att.status === "uploading" && <Loader size={14} className="spin" />}
            {att.status === "ready" && <Check size={14} />}
            {att.status === "error" && <AlertCircle size={14} />}
          </div>
          <button
            className="attachment-preview__remove"
            onClick={() => onRemove(att.id)}
            title={t("attachments.remove")}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
